<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0" >
         Configuración
      </h2>
    </div>
    <b-row>
      <b-col cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="Datos empresa" @click="goTo('config')" hoverable>
          <div class="d-flex align-items-center">
            <feather-icon icon="SettingsIcon" size="22" class="mr-2 text-info flex-shrink-0" />
            <span class="font-weight-bold">Configura los datos de la empresa</span>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="Horarios" @click="goTo('horarios')" hoverable>
          <div class="d-flex align-items-center">
            <ClockIcon size="22" class="mr-2 text-primary flex-shrink-0" />
            <span class="font-weight-bold">Gestiona los horarios de trabajo</span>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="Calendarios" @click="goTo('calendarios')" hoverable>
          <div class="d-flex align-items-center">
            <CalendarIcon size="22" class="mr-2 text-success flex-shrink-0" />
            <span class="font-weight-bold">Gestiona los calendarios laborales</span>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="Notificaciones" @click="goTo('notificaciones')" hoverable>
          <div class="d-flex align-items-center">
            <BellIcon size="22" class="mr-2 text-warning flex-shrink-0" />
            <span class="font-weight-bold">Configura las notificaciones</span>
          </div>
        </b-card>
      </b-col>
      <b-col v-if="canEditModuleVacaciones" cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="Convenio" @click="goTo('convenios')" hoverable>
          <div class="d-flex align-items-center">
            <BookOpenIcon size="22" class="mr-2 text-dark flex-shrink-0" />
            <span class="font-weight-bold">Gestiona la configuración de las solicitudes de ausencia</span>
          </div>
        </b-card>
      </b-col>
      <b-col v-if="role == 'super_admin'" cols="12" md="6" lg="4" class="d-flex mb-2">
        <b-card class="config-card" title="App versión" @click="goTo('app_version')" hoverable>
          <div class="d-flex align-items-center">
            <SmartphoneIcon size="22" class="mr-2 text-info flex-shrink-0" />
            <span class="font-weight-bold">Gestión de la versión de la App</span>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import { ClockIcon, CalendarIcon, BellIcon, SmartphoneIcon, BookOpenIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    ClockIcon,
    CalendarIcon,
    BellIcon,
    SmartphoneIcon,
    BookOpenIcon,
  },
  computed: {
    ...mapGetters({
      canEditModuleVacaciones: 'clients/getCanEditModuleVacations',
      role: 'auth/getRole',
    }),
  },
  methods: {
    goTo(section) {
      if (section === 'horarios') {
        this.$router.push({ name: 'horarios' })
      } else if (section === 'calendarios') {
        this.$router.push({ name: 'calendario' })
      } else if (section === 'notificaciones') {
        this.$router.push({ name: 'notificaciones' })
      } else if (section === 'config') {
        this.$router.push({ name: 'config' })
      } else if (section === 'convenios') {
        this.$router.push({ name: 'convenios' })
      } else if (section === 'app_version') {
        this.$router.push({ name: 'AppVersionEdit' })
      }
    },
  },
}
</script>

<style scoped>
.config-card {
  cursor: pointer;
  transition: box-shadow 0.2s;
  height: 100%;
  width: 100%;
  margin-bottom: 0;
}
.config-card:hover {
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
}
.config-card span {
  font-size: 0.85rem;
}
</style>
